import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { useEffect } from "react";
import { baseURL } from "../../Config/config";
import { Box } from "@mui/system";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, formLabelClasses, TextField } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import Projectcolors from "../../Utils/Colors";
import AddUserModal from "./AddUserModal";
import GlobalLoader from "./GlobalLoader";
import {IconButton} from "@mui/material";
import Typography from "@mui/material/Typography";

const tableHead = ["Username", "Password", "Edit", "Delete"];

export default function AdminTable(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [usersArray, setUsersArray] = React.useState([]);
  const [isEdit, setIsEdit] = React.useState();
  const [username, setUsername] = React.useState();
  const [password, setPassword] = React.useState();
  const [modalState, setModalState] = React.useState(false);
  const [pageUpdater, setPageUpdater] = React.useState(0);
  const [loader, setLoader] = React.useState(false);


  const toggleModal = (value) => {
    setModalState(value);
  };

  useEffect(async () => {
    await getAllusers();
  }, [pageUpdater]);

  const refreshList = async(value) => {  

    if(value){
      await getAllusers();
      return;
    }
    return;

  }


  const deleteUser = async (id) => {
    const body = {
      userID: id,
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };

    try {
      setLoader(true)
      let result = await fetch(`${baseURL}/deleteuser`, options);
      result = await result.json();
      if (result.code) {
        // setPageUpdater(pageUpdater + 1)
        // window.location.reload();
        await getAllusers()
        setLoader(false)
        return;
      }
      alert("There was some error");
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.log("error", error);
    }
  };

  const getAllusers = async () => {
    try {
      setLoader(true)
      let result = await fetch(`${baseURL}/getallusers`);
      result = await result.json();
      if (result.code) {
        const data = [];
        setIsEdit([])
        result.data.map((item, idx) => {
          setLoader(false)
          return data.push({
            id: item.user_id,
            username: item.username,
            password: item.password,
            editState: false,
          });
        });
        setLoader(false)
        setIsEdit(data);
        setLoader(false)
        setUsersArray(result.data);
        props.setTotalUsers(result.data.length);

        return;
      }
      alert("There was some error");
      setLoader(false)
    } catch (error) {
      setLoader(false)
      console.log("error", error);
    }
  };

  const handleUpdateUserApi = async (id) => {
    const body = {
      username,
      password,
      userID: id,
    };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    try {
      setLoader(true)

      let result = await fetch(`${baseURL}/updateuser`, options);
      result = await result.json();
      if (result.code) {
        await getAllusers()
        setLoader(false)
        return;

      }
      alert("There was some error");

    } catch (error) {
      console.log("error", error);
    }
  };

  const handleUpdate = async (i, user, pass, id) => {
    await handleUpdateUserApi(id);
  };

  const editFunc = (u, i, value) => {
    const data = [...isEdit];

    setIsEdit(
      data.map((d, idx) => {
        if (d.id === u) {
          setUsername(d.username);
          setPassword(d.password);
          return { ...d, editState: value };
        }
        return d;
      })
    );
  };



 return (
  <Box
    sx={{
      backgroundColor: "#fff",
      borderRadius: "16px",
    }}
  >
    {/* HEADER */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        background: "#f8fafc",
         px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
      }}
    >

      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          color: "#1e293b",
        }}
      >
        User Management
      </Typography>

      <Button
        onClick={() => toggleModal(true)}
        variant="contained"
        sx={{
          textTransform: "none",
          borderRadius: "10px",
          px: 2.5,
          py: 1,
          fontWeight: 600,
          background:
            "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
          boxShadow: "0 6px 15px rgba(0,0,0,0.12)",
          ":hover": {
            background:
              "linear-gradient(90deg, #095c9c 0%, #1f8bc7 100%)",
          },
        }}
      >
        Add User
      </Button>
    </Box>

    {/* TABLE */}
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: "14px",
        border: "1px solid #e2e8f0",
        maxHeight: "60vh",
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {tableHead.map((item) => (
              <TableCell
                key={item}
                sx={{
                  backgroundColor: "#f8fafc",
                  fontWeight: 700,
                  fontSize: "13px",
                  color: "#334155",
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {usersArray &&
            isEdit &&
            usersArray.map((item, idx) => (
              <TableRow
                hover
                key={idx}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f8fbff",
                  },
                }}
              >
                {/* USERNAME */}
                <TableCell sx={{ fontSize: "13px" }}>
                  {isEdit[idx]?.editState ? (
                    <TextField
                      variant="outlined"
                      defaultValue={item.username}
                      onChange={(e) =>
                        setUsername(e.target.value)
                      }
                      size="small"
                      fullWidth
                      InputProps={{
                        style: {
                          fontSize: "13px",
                          borderRadius: "8px",
                        },
                      }}
                    />
                  ) : (
                    item.username
                  )}
                </TableCell>

                {/* PASSWORD */}
                <TableCell sx={{ fontSize: "13px" }}>
                  {isEdit[idx]?.editState ? (
                    <TextField
                      type="password"
                      variant="outlined"
                      defaultValue={item.password}
                      onChange={(e) =>
                        setPassword(e.target.value)
                      }
                      size="small"
                      fullWidth
                      InputProps={{
                        style: {
                          fontSize: "13px",
                          borderRadius: "8px",
                        },
                      }}
                    />
                  ) : (
                    item.password
                  )}
                </TableCell>

                {/* EDIT */}
                <TableCell>
                  {isEdit[idx]?.editState ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() =>
                          handleUpdate(
                            idx,
                            item.username,
                            item.password,
                            item.user_id
                          )
                        }
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          background:
                            "linear-gradient(90deg, #0b6cb8 0%, #2da2df 100%)",
                          boxShadow: "none",
                        }}
                      >
                        Update
                      </Button>

                      <CancelIcon
                        onClick={() =>
                          editFunc(
                            item.user_id,
                            idx,
                            false
                          )
                        }
                        sx={{
                          color: "#dc2626",
                          cursor: "pointer",
                        }}
                      />
                    </Box>
                  ) : (
                    <IconButton>
                      <EditIcon
                        onClick={() =>
                          editFunc(
                            item.user_id,
                            idx,
                            true
                          )
                        }
                        sx={{
                          color: "#2563eb",
                          cursor: "pointer",
                        }}
                      />
                    </IconButton>
                  )}
                </TableCell>

                {/* DELETE */}
                <TableCell>
                  <IconButton>
                    <DeleteIcon
                      sx={{
                        color: "#dc2626",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        deleteUser(item.user_id)
                      }
                    />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>

    {/* MODAL */}
    <AddUserModal
      modalState={modalState}
      refreshList={refreshList}
      toggleModal={toggleModal}
    />

    {/* LOADER */}
    {loader ? <GlobalLoader /> : null}
  </Box>
);
}
